import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Moon, CloudFog, Frown, Cookie, Coffee, BatteryWarning } from 'lucide-react';
import { motion } from 'framer-motion';
const symptoms = [{
  icon: Moon,
  text: 'Te entra sueño 60–90 minutos después de comer'
}, {
  icon: CloudFog,
  text: 'Niebla mental: te cuesta pensar, decides peor'
}, {
  icon: Frown,
  text: 'Irritabilidad o "cero paciencia" a media tarde'
}, {
  icon: Cookie,
  text: 'Antojo de dulce que aparece "de la nada"'
}, {
  icon: Coffee,
  text: 'Café como muleta diaria para sobrevivir'
}, {
  icon: BatteryWarning,
  text: 'Llegas a la noche sin ganas de cocinar ni de nada'
}];
export function ProblemSection() {
  return <Section className="bg-white" data-id="element-304">
      <div className="text-center max-w-3xl mx-auto mb-8" data-id="element-305">
        <h2 className="text-3xl md:text-4xl font-bold text-[#2c4a2c] mb-3" data-id="element-306">
          Si tu tarde se rompe aquí, esto es para ti
        </h2>
        <p className="text-lg text-[#5a5a5a]" data-id="element-307">
          No es que "no puedas". Es que estás intentando sostener la tarde con
          gasolina que se quema demasiado rápido.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8" data-id="element-308">
        {symptoms.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="flex items-start gap-3 p-5 rounded-xl bg-[#faf8f5] border border-[#2c4a2c]/5 hover:border-[#c45d3a]/30 transition-colors" data-id="element-309">
            <div className="bg-[#c45d3a]/10 p-2.5 rounded-full shrink-0" data-id="element-310">
              <item.icon className="w-5 h-5 text-[#c45d3a]" data-id="element-311" />
            </div>
            <p className="text-[#2c4a2c] font-medium pt-0.5" data-id="element-312">{item.text}</p>
          </motion.div>)}
      </div>

      <div className="flex flex-col items-center gap-3" data-id="element-313">
        <Button variant="secondary" size="lg" data-id="element-314">
          Sí, me pasa
        </Button>
        <p className="text-sm text-[#5a5a5a]" data-id="element-315">
          No necesitas perfección. Necesitas un plan simple.
        </p>
      </div>
    </Section>;
}